import { css, styled } from '@lux/ds';

export const HeaderWrapper = styled('div')(
  ({ theme }) => css`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: flex-end;
    padding: 0 ${theme.space.m};
  `,
);

export const ActionsWrapper = styled('div')(
  ({ theme }) => css`
    align-items: center;
    display: flex;
    gap: ${theme.space.xl};
  `,
);
